import React, { useEffect, useState } from 'react';
import { makeApiRequest } from '../axiosService/apiCall';
import DataTable from 'react-data-table-component';
import config from "./config"
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';

function ClaimHistory() {
    const [claimHistory, setClaimHistory] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [copiedValue, setCopiedValue] = useState('');

    // console.log("claimHistory--", claimHistory);

    useEffect(() => {
        ClaimHistory();
    }, []);


    const ClaimHistory = async () => {
        try {
            let params = {
                url: `getClaimHistory`,
                method: 'GET',
            };
            let response = await makeApiRequest(params);
            // console.log("ClaimHistory--", response);
            if (response.status === true) {
                setClaimHistory(response.userClaimHistory);
            } else {
                setClaimHistory([]);
            }
        } catch (error) {
            // console.log('error', error);
        }
    };

   

    const compressString = (str) => {
        return str.length > 10 ? `${str.slice(0, 6)}...${str.slice(-4)}` : str;
    };
    const formatISTDate = (dateString) => {

        if (!dateString) return "-";


        const date = new Date(dateString);

        return date.toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true // For AM/PM format
        });
    };
    // const handleCopy = (value) => {
    //     setCopiedValue(value);
    //     setTimeout(() => setCopiedValue(''), 2000);
    // };
    const columns = [
        { name: 'S.No',  selector: (row) => row.sno },
        {
            name: 'Email',
            width: '350px',
            selector: (row) => row.email,
            cell: (row) => <div className="no-wrap-cell">{row.email}</div>,
        },
        {
            name: 'Claim Date',
            width: '200px',
            selector: (row) => row.claimDate,
            cell: (row) => <div className="no-wrap-cell">{formatISTDate(row.claimDate)}</div>,
        },
        {
            name: 'Stake Amount',
            width: "150px",
            selector: row => row.stakeAmount,
            cell: (row) => <div className="no-wrap-cell">{row.stakeAmount}</div>,
        },
        
        {
            name: 'Claimed Amount',
            width: '150px',
            selector: (row) => row.claimedAmount,
            cell: (row) => <div className="no-wrap-cell">{row.claimedAmount}</div>,
        },
        {
            name: 'Type',
            width: '150px',
            selector: (row) => row.type,
            cell: (row) => <div className="no-wrap-cell">
            {row.type === "Claimed" ? "Stake Claimed" :
             row.type === "ReStakeClaimed" ? "ReStakeClaimed" :
             row.type === "Re_ReStakeClaimed" ? "Re-ReStakeClaimed" :
             row.type}
        </div>,
        },
        
    ];

    const customSort = (rows, selector, direction) => {
        return rows.sort((a, b) => {
            if (typeof selector(a) === "string") {
                const aField = selector(a).toLowerCase();
                const bField = selector(b).toLowerCase();

                let comparison = 0;

                if (aField > bField) {
                    comparison = 1;
                } else if (aField < bField) {
                    comparison = -1;
                }
                return direction === 'desc' ? comparison * -1 : comparison;
            } else {
                const aField = selector(a).props.children ? parseFloat(selector(a).props.children) : 0;
                const bField = selector(b).props.children ? parseFloat(selector(b).props.children) : 0;
                let comparison = 0;

                if (aField > bField) {
                    comparison = 1;
                } else if (aField < bField) {
                    comparison = -1;
                }
                return direction === 'desc' ? comparison * -1 : comparison;
            }
        });
    };

    const formattedData = claimHistory && Array.isArray(claimHistory) ? claimHistory.map((row, index) => ({
        _id: row._id,
        sno: index + 1,
        email: row.userData.email ? row.userData.email : "-",
        stakeAmount: row.stakeAmount ? row.stakeAmount : "-",
        claimDate: row.claimDate ? row.claimDate : "-",
        claimedAmount: row.claimedAmount ? row.claimedAmount : "-",
        type: row.type ? row.type : "-",
    })) : [];

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setResetPaginationToggle(!resetPaginationToggle); // Reset pagination toggle
    };
    
    // console.log("formattedData==",formattedData);
    

    const filteredData = formattedData.filter(item =>
            item.email.toLowerCase().includes(searchTerm.toLowerCase())
        )
        .map((item, index) => ({
            ...item,
            sno: index + 1
        }));

    return (
        
        <div className='App'>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-12'>
                        <div className="custom-saled-order text-dark ms-3">
                            <div className="py-3 d-flex justify-content-between">
                                <h3 className="component-user">Claim History</h3>
                            </div>
                            <div>
                                <input
                                    type="text"
                                    placeholder="Search by Email"
                                    // style={{ "margin": "25px" }}
                                    value={searchTerm}
                                    onChange={handleSearch}
                                    className='form-search '
                                /> <br />
                                <div className='custom-datascroll'>
                                    {copiedValue && <div className="alert alert-success">Copied: {copiedValue}</div>}
                                    <DataTable
                                        className="text-center"
                                        columns={columns}
                                        data={filteredData}
                                        pagination
                                        persistTableHead
                                        sortFunction={customSort}
                                        paginationPerPage={5}
                                        paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                    />
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ClaimHistory